import BasicModel from '../basic/BasicModel'
export default {
  findQuestionUser(vm, params, listener) {
    let action = 'question/findQuestionUser.action'
    BasicModel.get(vm, action, params, listener)
  },
  selectQuestionInfo(vm,params,listener) {
    let action = 'question/selectQuestionInfo.action'
    BasicModel.get(vm, action, params, listener)
  },
  deleteQuestionReply(vm,params,listener) {
    let action = 'question/deleteQuestionReply.action'
    BasicModel.post(vm, action, params, listener)
  },
  deleteQuestion(vm,params,listener) {
    let action = 'question/deleteQuestion.action'
    BasicModel.post(vm, action, params, listener)
  },
  findUsers(vm,params,listener) {
    let action = 'question/findUsers.action'
    BasicModel.get(vm, action, params, listener)
  },
  selectUserQuestion(vm,params,listener) {
    let action = 'question/selectUserQuestion.action'
    BasicModel.get(vm, action, params, listener)
  },
  pushQuestion(vm,params,listener) {
    let action = 'question/pushQuestion.action'
    BasicModel.post(vm, action, params, listener)
  },
  addReply(vm,params,listener) {
    let action = 'question/addReply.action'
    BasicModel.post(vm, action, params, listener)
  },
  selectRandomVest(vm,params,listener) {
    let action = 'user/selectRandomVest.action'
    BasicModel.get(vm, action, params, listener)
  }
}
